import * as React from 'react';
import { IWalletDetails } from '@market/interfaces/IWallet';
import CurrencyElement from '@appComponents/CurrencyElement/CurrencyElement';
import { BalanceType } from '@profile/pages/CelsiusClaimPage/CelsiusClaimPage';

import * as style from './CurrencyRowStyles.module.scss'

type Props = {
  data: Pick<IWalletDetails, 'currency_name' | 'currency' | 'balance'> & {
    balance_type: BalanceType;
  };
  index: number;
};

const dotsBackgrounds = ['#d026ff', '#37a1ff', '#f7b501', '#48aa43'];
const walletsToDisplay = 4;

export const CurrencyRow = ({ data, index }: Props) => {
  const paintDot = (i: number) => {
    return { background: dotsBackgrounds[i] } as React.CSSProperties;
  };

  return (
    <div className={[style.currencyRow, style.decoration].join(' ')}>
      <div className={[style.item, style.itemName].join(' ')}>
        <div className={style.nameWrapper}>
          <div
            className={style.dot}
            style={index < walletsToDisplay ? paintDot(index) : undefined}
          />
          {data.currency_name}
        </div>
        <div className={style.pillWrapper}>
          <div className={[style.pill, style[`pill-${data.balance_type}`]].join(' ')}>
            {data.balance_type.split('_').join(' ')}
          </div>
        </div>
      </div>
      <div className={[style.item, style.itemValues].join(' ')}>
        <CurrencyElement
          currency={data.currency}
          value={data.balance}
          dataCy={`${data.currency}-balance`}
        />
      </div>
    </div>
  );
};
